// extracted by mini-css-extract-plugin
export default {"condensed":"styles__condensed--0fioU","more-label":"styles__more-label--KP7Vg"};